import { Message } from '@/interfaces/message';

/**
 * Moduł notyfikacji
 *
 * @export
 * @class NotificationModule
 */
export class NotificationModule {
  /**
   * Stan modułu
   *
   * @memberof NotificationModule
   */
  public state = {
    queue: []
  };

  public mutations = {
    /**
     * Dodaje notyfikację do kolejki
     *
     * @param localState stan lokalny
     * @param message notyfikacja
     */
    addMessage(localState: any, message: Message): void {
      localState.queue.push(message);
    },
    /**
     * Usuwa wiadomość z kolejki
     *
     * @param {*} localState
     */
    popMessage(localState: any, index: number): void {
      if (!index) {
        localState.queue.shift();
      } else {
        localState.queue.splice(index, 1);
      }
    }
  };

  public actions = {
    /**
     * Wyświetla notyfikację o błędzie
     *
     * @param context context
     * @param text tekst notyfikacji
     */
    notifyError(context: any, msg: object): void {
      context.dispatch('notify', { color: 'toast-error', message: msg });
    },
    /**
     * Wyświetla wiadomość o sukcesie
     * @param context context
     * @param text tekst notyfikacji
     */
    notifySuccess(context: any, msg: object): void {
      context.dispatch('notify', { color: 'toast-success', message: msg });
    },
    /**
     * Wyświetla notyfikację
     *
     * @param context context
     * @param obj notyfikacja
     */
    notify(context: any, obj: Message): void {
      context.commit('addMessage', { ...obj, id: 'msg_' + Date.now() });
    },
    /**
     * Ukrywa notyfikację
     *
     * @param context context
     */
    hideNotification(context: any, index: number): void {
      context.commit('popMessage', index);
    }
  };

  public getters = {
    /**
     * Pobiera liczbę notyfikacji w kolejce
     */
    countMessages: (localState: any): number => localState.queue.length,
    /**
     * Pobiera aktualną notyfikację
     */
    currentMessage: (localState: any): any => localState.queue[0]
  };
}

export default new NotificationModule();
